import { ThemeMenu } from '@/components/theme/ThemeMenu'
import {
  getAccountProfile,
  getInitials,
} from '@/features/account/model/account-profile'
import { Menu } from 'lucide-react'
import { Link } from 'react-router-dom'
import { ConfigMenu } from './ConfigMenu'

interface HeaderProps {
  onOpenNavigation: () => void
}

export function Header({ onOpenNavigation }: HeaderProps) {
  const profile = getAccountProfile()

  return (
    <header className="fixed inset-x-0 top-0 z-50 flex h-16 items-center border-b border-border-default bg-canvas px-4">
      <Link
        to="/dashboard"
        className="flex min-w-0 shrink-0 items-center gap-2 no-underline transition-opacity hover:opacity-80"
      >
        <img
          src="/assets/justlogo.png"
          alt="ForgeSphere logo"
          className="h-11 w-auto"
        />
        <span className="flex h-11 flex-col justify-center overflow-hidden max-[380px]:hidden">
          <span className="text-[0.65rem] leading-tight whitespace-nowrap text-muted">
            ProbeStack
          </span>
          <span className="font-heading gradient-text text-lg leading-tight font-extrabold whitespace-nowrap sm:text-xl">
            ForgeSphere
          </span>
        </span>
      </Link>

      <div className="flex-1" />
      <div className="mr-2">
        <ThemeMenu />
      </div>

      <ConfigMenu />

      <div className="hidden items-center gap-2 lg:flex">
        <Link
          to="/profile"
          title="Open profile"
          className="flex h-8 items-center gap-2 rounded-lg border border-border-default bg-raised/50 px-2 text-primary transition hover:border-accent-border/50 hover:bg-raised"
        >
          <span className="grid size-6 place-items-center rounded-full border border-accent-border/25 bg-accent-faint text-accent">
            <span className="text-[10px] font-bold" aria-hidden="true">
              {getInitials(profile.name)}
            </span>
          </span>
          <span className="min-w-0 text-left">
            <span className="block text-xs leading-4 font-semibold text-primary">
              {profile.name}
            </span>
            <span className="block text-[10px] leading-3 font-semibold tracking-widest text-muted uppercase">
              {profile.role}
            </span>
          </span>
        </Link>
      </div>

      <button
        type="button"
        aria-label="Open navigation menu"
        className="ml-auto grid size-8 place-items-center rounded-lg border border-border-default bg-raised/60 text-primary transition hover:border-accent-border/50 hover:bg-raised lg:hidden"
        onClick={onOpenNavigation}
      >
        <Menu size={18} aria-hidden="true" />
      </button>
    </header>
  )
}
